<template>
    <v-container>
        <v-card>
          <v-card-title>{{$t('human_resources.on_going_works')}}</v-card-title>
          <v-card-text>
                <v-row>
                    <v-col cols="12" md="3"></v-col>
                    <v-col cols="12" md="6">
                        <Chart
                            :key="globalWorksKey"
                            class="mt-16"
                            id="first-chart"
                            :options="globalWorkOptions"
                            :series="globalWorkSeries"
                            height="200"
                            width="100%"
                        />
                    </v-col>
                    <v-col cols="12" md="3"></v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card>
          <v-card-title>{{$t('human_resources.finished_works')}}</v-card-title>
          <v-card-text>
                <v-row>
                    <v-col cols="12" md="3"></v-col>
                    <v-col cols="12" md="6">
                        <Chart
                            :key="finishedGlobalWorksKey"
                            class="mt-16"
                            id="first-chart"
                            :options="globalWorkOptions"
                            :series="finishedGlobalWorkSeries"
                            height="200"
                            width="100%"
                        />
                    </v-col>
                    <v-col cols="12" md="3"></v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card>
          <v-card-title>{{$t('human_resources.usage')}}</v-card-title>
          <v-col cols="12" md="3">
          <Select
                v-model="choosenYear"
                :items="getYears"
                :label="$t('globals.year') + ' *'"
                prepend-inner-icon="mdi-clock"                
                @change="changeHumanYear"
            ></Select>
        </v-col>
          <v-card-text>           
            <v-row>
                <v-col cols="12">
                  <Chart
                    :key="humanResourceGraphKey"
                    class="mt-16"
                    id="first-chart"
                    :options="humanResourceGraphOptions"
                    :series="humanResourceGraphSeries"
                    height="250"
                  />
                </v-col>                
              </v-row>
              <v-row class="d-none d-sm-flex">
                <v-col cols="11">
                    <template>
                        <table style="width:100%;" class="ml-n16">
                            <thead>                                
                                <th v-for="h in headers" :key="h.text">
                                    {{h.text}}
                                </th>                                                             
                            </thead>
                            <tbody style="text-align: center;">
                                <tr>
                                    <td v-for="i in getItems" :key="i.id">{{i.data.extra}}</td>
                                </tr>
                                <tr>
                                    <td v-for="i in getItems" :key="i.id">{{i.data.faults}}</td>
                                </tr>
                                <tr>
                                    <td v-for="i in getItems" :key="i.id">{{i.data.holidays}}</td>
                                </tr>
                               <!-- <tr>
                                    <td v-for="i in getItems" :key="i.id">{{i.data.horse}}</td>
                                </tr>-->
                                <tr>
                                    <td v-for="i in getItems" :key="i.id">{{i.data.production}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
    </v-container>
</template>
<script>
import Chart from '@/components/ui/Chart.vue';
import Dashboard from "@/api/Dashboard.js";
import Select from '@/components/inputs/Select'

export default {
    components:{
        Chart,
        Select
    },
    data(){
        return{
            choosenYear: 2023,
            finishedGlobalWorksKey:0,
            globalWorksKey:0,
            tableType: 0,
            dashboardStatistics: null,
            humanResourceGraphKey: 0,
        }
    },
    async beforeMount(){
        this.$emit('loading')
        await this.generateStats()
        this.$emit('loaded')
    },
    methods:{
        async generateStats(){
            let parent = this
            let req = {
                year: this.choosenYear
            }
            await Dashboard.getStatistics(req).then(({data}) => {
                parent.dashboardStatistics = data
            });
        }, 
        changeHumanYear(){
            this.generateStats()
        }
    },
    computed:{
        values(){
            return [
                {
                    text: this.$t('human_resources.extra_hours')
                },
                {
                    text: this.$t('human_resources.faults')
                },
                {
                    text: this.$t('human_resources.holidays')
                },
                {
                    text: this.$t('human_resources.production')
                },
            ]
        },
        getYears(){
            let appYear = 2023
            let items = []
            const currentYear = new Date().getFullYear();

            for (let i = appYear; i <= currentYear; i++) {
                items.push(i)
            }

            return items
        },
        getItems(){
            let items = []
            
            
            if(this.dashboardStatistics == null) return []

            let parent = this

            this.dashboardStatistics.final_months.forEach(element => {
                if(items.length == 0){
                        items.push({
                        id: Math.floor(Math.random() * 99999) + 1,
                        data: {
                            'extra': parent.values[0].text,
                            'faults': parent.values[1].text,
                            'holidays': parent.values[2].text,
                            //'horse': parent.values[3].text,
                            'production': parent.values[3].text
                        }
                    })
                    items.push({
                        id: Math.floor(Math.random() * 99999) + 1,
                        data: element.data
                    })
                    
                }else{                    
                    items.push({
                        id: Math.floor(Math.random() * 99999) + 1,
                        data: element.data
                    })
                }
            });
            
            return items
        },
        headers(){
            if(this.dashboardStatistics == null) return []

            let headers = []
            headers.push({
                    text:   '-',
                    value:  'extra'
                })
            this.dashboardStatistics.final_months.forEach(element => {
                headers.push({
                    text:   element.month,
                    value:  'extra'
                })
            });
            return headers
        },
        humanResourceGraphSeries(){
          if(this.dashboardStatistics == null)
            return []

          let extra = []
          let production = []
          let horse = []
          let faults = []
          let holidays = []
          this.dashboardStatistics.final_months.forEach(element => {
            extra.push(element.data.extra)
            production.push(element.data.production)
            horse.push(element.data.horse)
            faults.push(element.data.faults)
            holidays.push(element.data.holidays)
          });

          let returner = [{
            name: this.$t('human_resources.extra_hours'),
            data: extra
          }, 
          {
            name: this.$t('human_resources.faults'),
            data: faults
          }, 
          {
            name: this.$t('human_resources.holidays'),
            data: holidays
          }, 
          {
            name: this.$t('human_resources.production'),
            data: production
          }]


          return returner
        },
        humanResourceGraphOptions(){
          return {
              colors: this.colors,
              chart: {
              type: 'bar',
              stacked: true,
              height: 350
              },  
              plotOptions: {
                  bar: {
                      borderRadius: 4,
                      horizontal: false,
                  }
                  },
                  dataLabels: {
                  enabled: false
                  },
                  xaxis: {
              type: 'text',
              categories: this.$t('globals.years'),
            },
            legend: {
              position: 'right',
              offsetY: 40
            },
            fill: {
              opacity: 1
            },
            responsive: [
                {
                breakpoint: 1000,
                options: {
                    plotOptions: {
                    bar: {
                        horizontal: false
                    }
                    },
                    legend: {
                        position: "top"
                    }
                }
                }
            ]
           
          } 
        },
        globalWorkOptions(){
            return {
                chart: {
                type: 'bar',
                height: 350
                },
                plotOptions: {
                bar: {
                    borderRadius: 4,
                    horizontal: true,
                }
                },
                dataLabels: {
                    enabled: true,
                    offsetX: -6,
                    textAnchor: 'end',
                    formatter: function (val) {
                        if(val == 0)
                            return ''
                        return val + '%'
                    },
                    style: {
                        fontSize: '12px',
                        colors: ['#fff'],
                    }
                },
                xaxis: {
                    categories: [this.$t('globals.total')],
                }
            }
        },
        globalWorkSeries(){
            if(this.dashboardStatistics == null)
                return []
                
            return [{
                data: [this.dashboardStatistics.average_works_course]
            }]
        },
        finishedGlobalWorkSeries(){
            if(this.dashboardStatistics == null)
                return []
                
            return [{
                data: [this.dashboardStatistics.average_works_finished]
            }]
        }
    }
}
</script>